import React from 'react';

const MainContainer = ({ children }) => {
    return (
        <div className="container">
            <div className="content-wrapper-width--tiny content-wrapper-align--center content-wrapper-vspace--mega">
                <div className="md:px-8">
                    { children }
                </div>
            </div>
        </div>
    );
};

export default MainContainer;
